import React from 'react';

const Telegram = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0C4.923 0 0 4.923 0 11s4.923 11 11 11 11-4.923 11-11S17.077 0 11 0zm5.402 7.536l-1.805 8.507c-.133.603-.492.75-.993.466l-2.75-2.027-1.327 1.277c-.146.147-.27.27-.554.27l.195-2.798 5.097-4.604c.221-.195-.05-.306-.342-.11l-6.298 3.965-2.715-.848c-.59-.186-.603-.59.124-.873L15.64 6.67c.493-.177.923.12.763.865z"
      fill="currentColor"
    />
  </svg>
);

export default Telegram;
